import React, { FunctionComponent } from 'react';
import { twMerge } from 'tailwind-merge';
import { concatClassNames } from '../../utils';

interface IInputProps {
  id?: string;
  label?: string;
  className?: string;
  error?: string;
  onChange?: (value: React.ChangeEvent<HTMLTextAreaElement>) => void;
  icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  wrapperClassName?: string;
  labelClassName?: string;
}

type TInputType = IInputProps & React.ComponentProps<'textarea'>;

/**
 * @deprecated This component is deprecated and should not be used in new code.
 * Please migrate to the new component.
 * @link src/lib/TextArea/TextArea.tsx
 */
const TextArea: FunctionComponent<TInputType> = (props) => {
  const { id, name, label, className, error, onChange, wrapperClassName, labelClassName, ...rest } = props;

  let inputStyle = 'block w-full px-4 sm:text-sm border border-gray-300 focus:border-blue-600 focus:border focus:outline-none rounded-md';

  if (props.icon) {
    inputStyle = concatClassNames(inputStyle, 'pl-10');
  }

  if (error) {
    inputStyle = concatClassNames(inputStyle, 'border-red-500 hover:border-red-500 focus:border-red-500');
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={twMerge('my-4', wrapperClassName)}>
      {label && (
        <label htmlFor={name} className={twMerge('block text-sm font-medium text-gray-700 py-2', labelClassName)}>
          {label}
        </label>
      )}
      <div className='relative mt-1 w-auto rounded-md'>
        {props.icon && (
          <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
            <props.icon className='mr-4 size-6 shrink-0 text-gray-500' />
          </div>
        )}
        <textarea id={id} name={name} onChange={handleChange} className={className ? concatClassNames(inputStyle, className) : inputStyle} {...rest} />
      </div>
      {error && <p className='mt-2 text-sm text-red-600'>{error}</p>}
    </div>
  );
};

export default TextArea;
